import { Injectable } from '@angular/core';
import { AttendeesPage } from '@routes/events/models/attendeelist-model';

@Injectable()
export class AttendeePagingService {
  public page: AttendeesPage = {
    'pageNumber': 0,
    'size': 20,
    'filterModel':  {
        'statusFilter': this.getStatusFilter(),
        'locationDateTimeFilter': null,
        'ticketHolderFilter': null,
        'contactTypeFilter': this.getContactTypeFilter(),
        'searchValue': '',
        'accountOwnerFilter': null,
        'groupFilter': null
    },
    'sortProperty': this.getSortProperty(),
    'sortDirection': this.getSortDirection(),
    'totalElements': 0,
    'totalPages': 0
  };

  public setStatusFilter(value: number) {
    localStorage.setItem('attendeesStatusFilter', value.toString());
  }

  public getStatusFilter(): number {
      let value = parseInt(localStorage.getItem('attendeesStatusFilter'), 10);
      if (isNaN(value)) {
        value = 0;
      }

      return value;
  }

  public setContactTypeFilter(value: number) {
    localStorage.setItem('attendeesContactTypeFilter', value.toString());
  }

  public getContactTypeFilter(): number {
      let value = parseInt(localStorage.getItem('attendeesContactTypeFilter'), 10);
      if (isNaN(value)) {
        value = 0;
      }

      return value;
  }

  public setSortProperty(value: string) {
    if (value) {
      localStorage.setItem('attendeesSortProperty', value);
    } else {
      localStorage.setItem('attendeesSortProperty', '');
    }
  }

  public getSortProperty(): string {
    let value = localStorage.getItem('attendeesSortProperty');
    if (null === value) {
        value = '';
    }

    return value;
  }

  public setSortDirection(value: string) {
    if (value) {
      localStorage.setItem('attendeesSortDirection', value);
    } else {
      localStorage.setItem('attendeesSortDirection', '');
    }
  }

  public getSortDirection(): string {
    let value = localStorage.getItem('attendeesSortDirection');
    if (null === value) {
        value = '';
    }

    return value;
  }

}
